module.exports = __webpack_public_path__ + "static/media/house_of_cards.04fc1fb7.jpg";